import React from 'react';

const Score = (props) => (
    <svg
        width="21px"
        height="22px"
        viewBox="0 0 21 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/Score b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-388.000000, -2011.000000)" fill="#000000">
                <g id="Icon/Score-b" transform="translate(388.000000, 2011.000000)">
                    <path
                        d="M15.4055222,20.4830612 L15.394803,20.4892849 C13.8523781,21.4469784 12.0324383,22 10.0833333,22 C8.1295451,22 6.30554345,21.4443176 4.76075008,20.4823745 C5.16081323,20.2204001 5.50605391,19.8817044 5.77629211,19.4875484 C7.04587923,20.2110816 8.51626837,20.625 10.0833333,20.625 C11.6500239,20.625 13.1200848,20.2112794 14.3902235,19.4871306 C14.6606128,19.8817044 15.0058534,20.2204001 15.4055222,20.4830612 Z M6.41666667,2.75 C6.41666667,3.16247442 6.48477471,3.55904135 6.61035823,3.92906824 C3.52982316,5.26897457 1.375,8.34117766 1.375,11.9166667 C1.375,12.6101844 1.4560692,13.2847674 1.60924792,13.931456 C1.14924115,14.0813789 0.729332189,14.3203222 0.36959795,14.627645 C0.128469241,13.7655181 0,12.8560952 0,11.9166667 C0,7.63852095 2.66429805,3.98265538 6.4241651,2.51779903 C6.41910085,2.59461175 6.41666667,2.67202161 6.41666667,2.75 Z M20.1666667,11.9166667 C20.1666667,12.8560952 20.0381974,13.7655181 19.7978691,14.6283254 C19.4380317,14.320719 19.0178074,14.0815038 18.5574665,13.9309398 C18.7105975,13.2847674 18.7916667,12.6101844 18.7916667,11.9166667 C18.7916667,8.34152293 16.6372597,5.26956792 13.5558846,3.92824058 C13.681892,3.55904135 13.75,3.16247442 13.75,2.75 C13.75,2.6716796 13.7475444,2.59393273 13.742706,2.51683218 C17.5018987,3.98201055 20.1666667,7.63814365 20.1666667,11.9166667 Z"
                        id="Combined-Shape"
                        fill-rule="nonzero"
                    ></path>
                    <circle id="Oval" cx="10.0833333" cy="2.75" r="2.75"></circle>
                    <circle id="Oval-Copy-2" cx="2.75" cy="17.4166667" r="2.75"></circle>
                    <circle id="Oval-Copy-3" cx="17.4166667" cy="17.4166667" r="2.75"></circle>
                </g>
            </g>
        </g>
    </svg>
);

export default Score;
